module.exports = __webpack_public_path__ + "static/media/Pencil.38828042.jpg";